import React from 'react';
import { Box, Text, Button } from 'grommet';
import { More } from 'grommet-icons';
import Icon from '@mdi/react';
import { mdiContentCopy } from '@mdi/js';
import useClippy from 'use-clippy';
import { isItemNew } from '../../../utils';
import { EMBEDONPAGE, PAGEOVERLAY } from './embedded-flow-config.actions';

export const ProgressionOverlay = 'Progression | Overlay';
const ProgressionPageEmbed = 'Progression | Page Embed';

// Get the ad unit template by id
export const getAdUnitTemplate = (adUnitTemplates, id) => {
  return adUnitTemplates.find(template => template.id === id);
};

// Get the legacy template
export const getLegacyTemplate = embeddedFlowConfig => {
  switch (embeddedFlowConfig.implementationType) {
    case EMBEDONPAGE:
      return `${ProgressionPageEmbed}`;
    case PAGEOVERLAY:
      return `${ProgressionOverlay}`;
    default:
      return `${ProgressionOverlay}`;
  }
};

const renderTemplateName = (embeddedFlowConfig, templateType) => {
  if (
    !embeddedFlowConfig.implementationType ||
    embeddedFlowConfig.implementationType === PAGEOVERLAY ||
    embeddedFlowConfig.implementationType === EMBEDONPAGE
  ) {
    return `Configuration Template: Flow: ${templateType}`;
  } else {
    return `Configuration Template: ${templateType}`;
  }
};

const ConfigurationTemplateButton = ({
  adUnitTemplates,
  customAdUnitTemplates,
  embeddedFlowConfig,
  setOpenModal,
  setTemplateType = () => {},
  addSuccess,
  canEdit
}) => {
  const [, setClipboard] = useClippy();
  const templates = [...adUnitTemplates, ...customAdUnitTemplates];
  const templateType =
    embeddedFlowConfig.adUnitTemplateId !== null
      ? `${getAdUnitTemplate(templates, embeddedFlowConfig.adUnitTemplateId)
          ?.name ||
          getAdUnitTemplate(templates, embeddedFlowConfig.adUnitTemplateId)
            ?.templateName}`
      : `${getLegacyTemplate(embeddedFlowConfig)}`;

  // Set the template type and remove any whitespace
  setTemplateType(templateType.replace(/\s+/g, ''));

  return (
    <Box margin={{ bottom: 'medium' }} gap='medium'>
      {embeddedFlowConfig.adUnitTemplateId === null && (
        <Box background='brand300' pad='small' round='small'>
          <Text color='#000'>
            <strong>Note:</strong>
            {isItemNew(embeddedFlowConfig.id)
              ? ` By selecting the Flow Configuration, you are not leveraging the most efficient or functional version of ad unit serving. Though it is not required, it is recommended to use an Ad Unit Configuration. To do so, click the discard button to pick a new template.`
              : ` By using the Flow Configuration, you are not leveraging the most efficient or functional version of ad unit serving. Switch to an Ad Unit Configuration for optimal performance.`}
          </Text>
        </Box>
      )}

      <Box direction='row' align='center' justify='between'>
        <Box direction='row' align='center'>
          <Text weight='bold' margin={{ right: 'small' }}>
            {renderTemplateName(embeddedFlowConfig, templateType)}
          </Text>
          <Button
            onClick={() => setOpenModal(true)}
            disabled={!canEdit}
            icon={<More size='small' />}
            style={{ padding: '5px 15px', marginRight: '8px' }}
          />
        </Box>
        <Box direction='row' align='center' gap='xsmall'>
          <Text>
            <span style={{ fontWeight: 'bold' }}>Config ID</span>
            {`: ${
              !isItemNew(embeddedFlowConfig.id)
                ? embeddedFlowConfig.id
                : 'Configuration ID will be generated upon saving.'
            }`}
          </Text>
          {!isItemNew(embeddedFlowConfig.id) && (
            <Icon
              path={mdiContentCopy}
              size={'14px'}
              cursor='pointer'
              onClick={() => {
                setClipboard(embeddedFlowConfig.id);
                addSuccess('Configuration ID copied to clipboard');
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ConfigurationTemplateButton;
